// extracted by mini-css-extract-plugin
module.exports = {"container":"_0cbaba7d8a--container--pw9xx","with-max-width":"_0cbaba7d8a--with-max-width--tekWt","title":"_0cbaba7d8a--title--YNjaW"};